import { useEffect, useMemo } from 'react'
import { IGroup } from '@obvious.tech/constellation'

import api, { TApiError, TApiResponse, TEntity } from 'src/utils/api'
import { TLoadable } from 'src/utils/Loadable'

const getGroupsByIDs = async ({
  ids,
  token,
}: {
  ids: string[]
  token?: string
}): Promise<TApiResponse<Array<TEntity<IGroup>>, TApiError>> => {
  if (ids.length === 0) {
    return await Promise.resolve<TApiResponse<Array<TEntity<IGroup>>, never>>({
      _tag: 'success',
      data: [],
    })
  }

  return await api.getResourcesWithFilters<TEntity<IGroup>>(
    'authentication/api/Group',
  )({
    token,
    filters: [['id', api.Filter.Eq, ids]],
  })
}

export type TUseAssignedGroupsResult = TLoadable<
  Array<TEntity<IGroup>>,
  TApiError
>

export type TProps = {
  ids: string[]
  authorization?: string
}

const useAssignedGroups = ({
  ids,
  authorization,
}: TProps): TUseAssignedGroupsResult => {
  const [groups, getGroups] = api.useApiAction(getGroupsByIDs)

  const key = ids.join(',')
  const stableIds = useMemo(() => (key === '' ? [] : key.split(',')), [key])

  useEffect(() => {
    return getGroups({ ids: stableIds, token: authorization })
  }, [stableIds, authorization, getGroups])

  return groups
}

export default useAssignedGroups
